/* unplugin-vue-components disabled */import script from "./PmAlertDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PmAlertDialog.vue?vue&type=script&setup=true&lang=js"

import "./PmAlertDialog.vue?vue&type=style&index=0&id=ccd8b2ee&lang=scss"

const __exports__ = script;

export default __exports__